import { controller, target } from "@github/catalyst"
import { install, uninstall } from "@github/hotkey"

// Wraps a link that carries a `data-hotkey` attribute and binds the shortcut
// to it. Turbo Drive swaps the <body> on navigation, so the binding is set up
// in connectedCallback and torn down in disconnectedCallback to avoid leaking
// a handler for a link that is no longer on the page.
@controller
class HotkeyLinkElement extends HTMLElement {
  @target link!: HTMLAnchorElement

  connectedCallback() {
    install(this.link)
  }

  disconnectedCallback() {
    uninstall(this.link)
  }
}

export default HotkeyLinkElement
